module.exports = __webpack_public_path__ + "img/1.b113ead8.png";